/** @flow */
import merge from 'deepmerge';

import Colors from 'common/themes/Colors';

const myColor = {
  primary: '#49aae2',
  darkPrimary: '#0980c6',
  primaryText: '#4d4c4d', // #808080
  secondaryText: '#212121',
  tertiaryText: '#FFFFFF',
  primaryBackground: '#f5f5f5',
  secondaryBackground: '#EEEEEE',
  darkBackground: '#0980c6',
  disabled: '#a3a2a0',
  accent: '#04709F',
  secondaryAccent: '#49aae2',
  divider: '#c8c8c8',
  border: '#AFAFAF',
  lightGray: '#AEAEAE',
  whiteHoverBackground: '#fafafa',
  darkGray: '#3C3C3C',
  increaseStats: '#49aae2', // #188c7b
  decreaseStats: 'rgb(169, 30, 33)',
  cancel: 'rgb(169, 30, 33)',
  female: '#79d7ff',
  male: '#0980c6',
  graphBorderAndText: 'rgb(102, 102, 102)',
  cardBackground: '#FFFFFF',
  tooltipBackground: 'rgba(0, 0, 0, 0.7)',
  error: 'red',
};

export default merge.all([
  Colors,
  myColor,
]);



// WEBPACK FOOTER //
// ./src/advertisers/themes/Colors.js